<template>
    <v-container class="fill-height pa-0 pb-0" fluid>
        <v-row class="fill-height">
            <v-col class="d-flex justify-center align-self-center flex-column">
                <v-row>
                    <v-col cols="10" class="d-flex justify-center align-self-center flex-column ml-auto mr-auto">
                        <div class="d-flex flex-column align-center pb-10">
                            <img alt="" src="../../assets/logo-login.png" class="align-self-center" height="60px" />
                            <router-link to="/" class="text-decoration-none font-weight-bold">
                                Channel Optimiser
                            </router-link>
                        </div>
                        <div class="text-h3 pb-3 text-center">Welcome Back</div>
                        <v-btn
                            disabled
                            prepend-icon="mdi-google"
                            variant="outlined"
                            rounded="xl"
                            size="x-large"
                            class="text-none"
                        >
                            Login with Google
                        </v-btn>
                        <div class="pa-5 text-center">or login by email:</div>
                        <v-form @submit="onSubmit">
                            <v-label>UserName</v-label>
                            <v-text-field
                                placeholder="UserName"
                                v-model="email"
                                v-bind="emailAttrs"
                                :error-messages="errors.email"
                                variant="solo"
                                density="compact"
                                autocomplete="off"
                            ></v-text-field>
                            <v-label>Password</v-label>
                            <v-text-field
                                placeholder="Password"
                                type="password"
                                v-model="password"
                                v-bind="passwordAttrs"
                                :error-messages="errors.password"
                                variant="solo"
                                density="compact"
                                autocomplete="off"
                            ></v-text-field>
                            <div class="d-flex justify-center">
                                <v-btn
                                    class="mt-2 text-none"
                                    type="submit"
                                    :loading="isSubmitting"
                                    rounded="xl"
                                    size="x-large"
                                    variant="elevated"
                                    base-color="primary"
                                    :disabled="Object.keys(errors).length > 0"
                                >
                                    Login
                                </v-btn>
                            </div>
                        </v-form>
                        <div class="pa-10 text-center">Version 1.0</div>
                    </v-col>
                </v-row>
            </v-col>
            <v-col class="bg-white">
                <div class="text-h4 pa-10">
                    Helping the World's Leading Brands to Grow Profitably & Sustainably Online
                </div>
                <img alt="" src="../../assets/background.png" />
            </v-col>
        </v-row>
    </v-container>
</template>

<script lang="ts" setup>
import { inject } from 'vue'
import { ApiPluginInterface } from '@/plugins/api-plugin'
import { useForm } from 'vee-validate'
import SignInDto from '@/interfaces/common/SignIn.dto'
import { signInDtoSchema } from '@/schemas/common/signIn.dto.schema'
import { useAuthStore } from '@/stores/useAuthStore'

const api = inject<ApiPluginInterface>('api')

const storeAuth = useAuthStore()

const { errors, handleSubmit, defineField, isSubmitting } = useForm<SignInDto>({
    validationSchema: signInDtoSchema,
})

const onSubmit = handleSubmit(async (values) => {
    await storeAuth.login(values.email, values.password, api)
})

const [email, emailAttrs] = defineField('email')
const [password, passwordAttrs] = defineField('password')
</script>
